<script setup>
  import { format } from "date-fns";
  import { ko } from "date-fns/locale";
  import { computed } from "vue";

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
    /*prevItem: {
      type: Object,
      default: null,
    },
    nextItem: {
      type: Object,
      default: null,
    },*/
  });

  // URL을 클릭 가능한 링크로 변환하는 함수
  const convertUrlsToLinks = (text) => {
    if (!text) return '';
    
    // 이미 HTML 태그가 있는지 확인
    const hasHtmlTags = /<[^>]+>/g.test(text);
    
    if (hasHtmlTags) {
      // HTML 태그가 있는 경우, 태그 밖의 텍스트만 처리
      return text.replace(/>[^<]*</g, (match) => {
        const content = match.slice(1, -1); // > 와 < 제거
        if (!content.trim()) return match;
        
        // URL 정규식 (http, https, www로 시작하는 URL 감지)
        const urlRegex = /(https?:\/\/[^\s<>]+|www\.[^\s<>]+)/gi;
        const processedContent = content.replace(urlRegex, (url) => {
          // 이미 링크 태그 안에 있는지 확인
          const beforeMatch = text.substring(0, text.indexOf(match));
          const isInsideLink = /<a[^>]*$/.test(beforeMatch) && !/<\/a>/.test(beforeMatch);
          
          if (isInsideLink) return url; // 이미 링크 안에 있으면 그대로 반환
          
          // www로 시작하는 경우 http:// 추가
          const href = url.startsWith('www.') ? `http://${url}` : url;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">${url}</a>`;
        });
        
        return `>${processedContent}<`;
      });
    } else {
      // HTML 태그가 없는 경우, 전체 텍스트에서 URL 찾아서 변환
      const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
      return text.replace(urlRegex, (url) => {
        // www로 시작하는 경우 http:// 추가
        const href = url.startsWith('www.') ? `http://${url}` : url;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">${url}</a>`;
      });
    }
  };

  // 메시지 내용을 URL 링크로 변환
  const processedMessage = computed(() => {
    return convertUrlsToLinks(props.item.msg);
  });

  // 첨부 이미지 목록 (getDmList의 attach_list JSON 문자열)
  const attachImages = computed(() => {
    try {
      const parsed = JSON.parse(props.item.attachList || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });

  /*const shouldShowTime = computed(() => {
    // nextItem 없으면 (즉 마지막 메시지) → 무조건 표시
    if (!props.nextItem) return true;

    // 타입이 다르면 표시
    if (props.nextItem.type !== props.item.type) return true;

    // 같은 타입인데 시간(분 단위) 같으면 숨김
    const currentTime = format(props.item.time, "HH:mm");
    const nextTime = format(props.nextItem.time, "HH:mm");

    return currentTime !== nextTime;
  });*/
</script>

<template>
  <div class="msg-box" :class="`type-${item.fromMsg}`">
    <div class="msg-tail"></div>
    <div class="msg-content">
      <div v-if="item.msg" v-html="processedMessage"></div>
      <n-image-group v-if="attachImages.length > 0">
        <n-flex :size="4" class="msg-images" :class="{ 'mt-1': item.msg }">
          <n-image
            v-for="(img, imgIndex) in attachImages"
            :key="`msg-img-${imgIndex}`"
            :src="img.url"
            :alt="img.fileName"
            object-fit="cover"
            :width="attachImages.length > 1 ? 96 : 180"
          />
        </n-flex>
      </n-image-group>
      <n-flex vertical v-if="item.buttons" class="mt-2" :size="4">
        <ui-button
          v-for="(button, buttonIndex) in item.buttons"
          :key="`${item.date}-btn-${buttonIndex}`"
          variant="outlined"
          size="tiny"
          class="justify-start font-normal"
          >{{ button.label }}</ui-button
        >
      </n-flex>
<!--      <div v-if="shouldShowTime" class="msg-time">-->
      <div class="msg-time">
        {{ item.rgstDt }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .msg-box {
    display: block;
    max-width: 80%;
    position: relative;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.05);
    .msg-tail {
      display: block;
      width: 1rem;
      height: 1rem;
      background: var(--msg-bg-color);
      position: absolute;
      bottom: 0.5rem;
      border-radius: 0.25rem;
      transform: rotate(45deg);
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.05);
      z-index: 0;
    }
    .msg-content {
      font-size: 0.875rem;
      padding: 0.75rem 1rem;
      background: var(--msg-bg-color);
      position: relative;
      border-radius: 0.625rem;
      word-wrap: break-word;
      word-break: break-word;
      overflow-wrap: break-word;
      .msg-time {
        font-size: 0.75rem;
        color: var(--smoe-gray-600);
        margin-top: 0.25rem;
      }
      .msg-images {
        :deep(.n-image img) {
          border-radius: 0.375rem;
          cursor: zoom-in;
        }
      }
    }
    &.type-admin {
      --msg-bg-color: var(--smoe-white);
      align-self: flex-start;
      .msg-tail {
        left: -0.25rem;
      }
    }
    &.type-tea {
      --msg-bg-color: var(--smoe-primary-200);
      align-self: flex-end;
      .msg-tail {
        right: -0.25rem;
      }
    }
  }
</style>
